import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
const { default: apiClient } = require("lib/api-client");

export const getParticularData = async({ pageParam = 1,queryKey}) =>{
    const [,{actionType,search,limit}] = queryKey;

    const response = await apiClient.post("/api/v1/sync/getDyanamicParticularSyncData",{
        actionType,
        search,
        pageNumber:pageParam,
        limit
    });

    if (response.status !== 200) {
        throw new Error("Error in the fetching data");
    }

    return {
        syncAllData:response?.data?.syncAllData,
        totalCount:response?.data?.totalCount
    };
}

export const useGetParticularList = ({actionType="",search="",limit}) =>{
    return useInfiniteQuery({
        queryKey:["getParticularSyncList",{actionType,search,limit}],
        queryFn:({pageParam = 1})=>getParticularData({ pageParam,queryKey:["getParticularSyncList",{actionType,search,limit}]}),
        getNextPageParam: (lastPage, allPages) => {
            return allPages.length + 1;
        },
        staleTime: 5 * 60 * 1000,
    })
}

// export const useGetParticularList = ({actionType="",search=""}) =>{
//     return useQuery({
//         queryKey:["getParticularSyncList",{actionType,search}],
//         queryFn:()=>getParticularData({queryKey:["getParticularSyncList",{actionType,search}]}),
//         staleTime : 5*60*1000,
//     })
// }